export default __webpack_public_path__ + "static/media/Gregory W Meeks.29fc5e4f.jpg";